module.exports = __webpack_public_path__ + "static/media/overview4_1.bf02fbe7.png";